import { EnvironmentOverlay } from './Layout/environmentOverlay/EnvironmentOverlay'
import { UnprotectedRoutes } from './auth/UnprotectedRoutes'
import { AppProviders } from './providers/AppProviders'

import './App.scss'
import '@mantine/core/styles.css'
import '@mantine/tiptap/styles.css'
import '@mantine/dates/styles.css'

export function UnconnectedApp() {
  return (
    <AppProviders>
      <EnvironmentOverlay />
      <UnprotectedRoutes />
    </AppProviders>
  )
}

export const App = UnconnectedApp
